import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'

import 'swiper/scss'

import styles from './event_carousel.module.sass'

import BlockWrapper from '../layout/block_wrapper'
import Button from '../basic/button'
import Link from '../basic/link'

function EventCarousel(props) {
	let fields = props.fields
	const [carouselItems, setCarouselItems] = useState([])

	const sliderConfig = {
		modules: [Navigation],
		spaceBetween: 20,
		slidesPerView: 3,
		slidesPerGroup: 3,
		loop: false,
		watchSlidesProgress: true,
		navigation: {
			prevEl: `.${styles.previous}`,
			nextEl: `.${styles.next}`,
			clickable: true
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 10
			},
			900: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1240: {
				slidesPerView: 3,
				spaceBetween: 20
			},
		}
	}

	const handleMouseEvent = (index) => {
		setCarouselItems(
			carouselItems.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	useEffect(() => {
		const decorateCarouselItems = fields.items.map(obj => ({ ...obj, buttonActive: false }))
		setCarouselItems(decorateCarouselItems)
	}, [])

	return <BlockWrapper {...props} className={styles.event_carousel}>
		<div className={styles.carousel_wrapper}>
			<button className={styles.previous}></button>
			<Swiper className={styles.carousel} {...sliderConfig}>
				{carouselItems && carouselItems.map((item, index) => {
					return <SwiperSlide 
						onMouseEnter={() => handleMouseEvent(index)}
						onMouseLeave={() => handleMouseEvent()}
						className={styles.carousel_item} 
						key={index}
					>
						<Link href={item.guid}>
							<h3>{item.post_title}</h3>
							<div className={styles.content} dangerouslySetInnerHTML={{ __html: item.post_excerpt}} />
							<Button className={styles.button} appearance='solid' color='white' active={item.buttonActive}>View Details</Button>
						</Link>
					</SwiperSlide>
				})}
			</Swiper>
			<button className={styles.next}></button>
		</div>
	</BlockWrapper>
}

export default EventCarousel